import React from 'react';
import PropTypes from 'prop-types';
import './Notification.scss';

const Notification = props =>
  <div className="notification-container">
    <div className="notification-text autotest-notification-text">
      {props.children}
    </div>
  </div>
;

Notification.propTypes = {
  children: PropTypes.node
};

export default Notification;



/** WEBPACK FOOTER **
 ** ./src/components/Notification/Notification.js
 **/